export function reorderArrayItem<T>(
  array: T[],
  oldIndex: number,
  newIndex: number,
): T[] {
  if (newIndex >= array.length) throw new Error("New index is out of bounds");
  const result = [...array];
  const [removed] = result.splice(oldIndex, 1);
  result.splice(newIndex, 0, removed);
  return result;
}
